/* eslint-disable no-param-reassign */
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { connect } from "react-redux";
import "./SuccessModal.css";
import Icons from "./Icons";

function SuccessModal({ onClose }) {
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open
      className="successDialogWrapper"
      onClose={onClose}
    >
      <DialogContent className="dialog-content">
        <div className="content-wrapper-success-modal">
          <Icons.CheckGreenIcon />
          <div className="text-message">Changes saved</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default connect(null, null)(SuccessModal);
